import { isoDayToDate } from "./dates";

interface PlanningDates {
  start?: string | null;
  end?: string | null;
}

interface SessionWithPlanning {
  planning_dates?: PlanningDates | null;
}

function startOfDay(date: Date): Date {
  const result = new Date(date);
  result.setHours(0, 0, 0, 0);
  return result;
}

/**
 * Whether the session is currently in its planning phase, i.e. today falls
 * within `planning_dates.start`..`planning_dates.end` (inclusive). The dates are
 * ISO days.
 */
export function isSessionInPlanning(
  session: SessionWithPlanning | null | undefined,
  now: Date = new Date(),
): boolean {
  const start = session?.planning_dates?.start;
  const end = session?.planning_dates?.end;
  if (!start || !end) return false;

  const today = startOfDay(now);
  const rangeStart = isoDayToDate(start)!;
  const rangeEnd = isoDayToDate(end)!;

  return today >= rangeStart && today <= rangeEnd;
}
